import bundleHandler from './bundle-handler.js';
import bundleSellsHandler from './bundle-sells-handler.js';
import wcsAttHandler from './wcs-att-handler.js';

export const handlers = [bundleHandler, bundleSellsHandler, wcsAttHandler];
